<template>
  <section
    class="client-section bg-seashell d-flex flex-column align-items-center justify-content-center"
    style="background-color: rgba(221, 182, 87, 0.07)"
  >
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-12 col-md-6 text-center margin-1-half-rem-bottom d-flex flex-column align-items-center justify-content-center gap-3"
        >
          <div
            class="d-flex flex-row align-items-center justify-content-center text-center margin-10px-bottom gap-2"
          >
            <span
              style="
                width: 25px;
                height: 1px;
                background-color: #000;
                font-weight: bold;
              "
            ></span>
            <div style="font-size: 16px; color: #000; font-weight: 500">
              Our Partners
            </div>
            <span
              style="
                width: 25px;
                height: 1px;
                background-color: #000;
                font-weight: bold;
              "
            ></span>
          </div>
          <h5 style="font-weight: bold; font-size: 32px; color: #232323">
            ALJABIRI Holding Group
          </h5>
        </div>
      </div>
    </div>

    <div class="container d-flex align-items-center justify-content-center">
      <div class="row client-logo-style-03 carousel-width">
        <div class="col-12 position-relative">
          <Swiper
            @swiper="onSwiper"
            :modules="modules"
            :loop="true"
            :slides-per-view="1"
            :space-between="30"
            :autoplay="{ delay: 3000, disableOnInteraction: false }"
            :breakpoints="{
              500: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            class="mySwiper text-center"
          >
            <SwiperSlide v-for="(logo, index) in logos" :key="index">
              <img :src="logo" alt="client logo" class="client-logo" />
            </SwiperSlide>
          </Swiper>
          <button
            @click="goPrev"
            class="border-0 d-flex align-items-center justify-content-center position-absolute top-50 translate-middle"
            style="
              background-color: white;
              border-radius: 999px;
              width: 40px;
              height: 40px;
              left: -30px;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0
                   -.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 
                   .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
              />
            </svg>
          </button>

          <button
            @click="goNext"
            class="border-0 d-flex align-items-center justify-content-center position-absolute top-50 translate-middle"
            style="
              background-color: white;
              border-radius: 999px;
              width: 40px;
              height: 40px;
              right: -60px;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 
                   .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 
                   8.5H1.5A.5.5 0 0 1 1 8"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </section>
  <footer>
    <div class="top-footer">
      <div class="container">
        <div
          class="top d-flex flex-column justify-content-center align-items-center"
        >
          <h3 class="heading">Key Stats & Global Impact</h3>
          <div class="statics d-flex justify-content-center align-items-center">
            <div
              class="block d-flex flex-column justify-content-center align-content-center"
            >
              <span class="num text-center">{{ formatNumber(counters[0]) }}</span>
              <span class="text">Years of Experience</span>
            </div>
            <div
              class="block d-flex flex-column justify-content-center align-content-center"
            >
              <span class="num text-center">{{ formatNumber(counters[1]) }}</span>
              <span class="text">Investment Sectors</span>
            </div>
            <div
              class="block d-flex flex-column justify-content-center align-content-center"
            >
              <span class="num text-center">{{ formatNumber(counters[2]) }}</span>
              <span class="text">Global Offices</span>
            </div>
            <div
              class="block d-flex flex-column justify-content-center align-content-center"
            >
              <span class="num text-center">{{ formatNumber(counters[3]) }}</span>
              <span class="text">International Clients</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-footer" style="padding-left: 0px; padding-right: 0px">
      <div class="container">
        <div class="footer-margin">
          <div class="content">
            <div class="row">
              <div class="col-lg-5 col-md-4 col-sm-5 col-12 mb-3">
                <div class="row">
                  <div class="col-lg-6 col-sm-8 col-6">
                    <router-link to="/" class="w-100">
                      <img src="/images/logof.png" alt="logo" class="w-75" />
                    </router-link>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div
                      class="d-flex main align-items-start"
                      style="gap: 50px"
                    >
                      <p class="text-start no-anim">
                      Aljabiri Group Holding: an Arab family-owned, multi-sector investment platform. Rooted in heritage, we deploy patient capital to connect regions and drive sustainable growth in food, healthcare, digital, and manufacturing.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 col-sm-3 col-6 mb-3">
                <div class="links quick d-flex flex-column align-items-start">
                  <h4 class="mb-4">Quick Links</h4>
                  <ul class="list d-flex flex-column align-items-start gap-2">
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/about">About Us</router-link></li>
                    <li>
                      <router-link to="/services">Our Services</router-link>
                    </li>
                    <li>
                      <router-link to="/foundation"
                        >Foundation & Impact</router-link
                      >
                    </li>
                    <!-- <li><a href="#">Our Projects</a></li> -->
                    <!-- <li><a href="#">Our Partners</a></li> -->
                    <!-- <li><a href="#">FAQs</a></li> -->
                  </ul>
                </div>
              </div>
              <div class="col-md-2 col-sm-4 col-6 mb-3">
                <div class="links d-flex flex-column align-items-start">
                              <h4 class="mb-4">Quick Links</h4>
                  <ul class="list d-flex flex-column align-items-start gap-2">
                    <li><router-link to="/investor-relations">Investor Relations</router-link></li>
                    <li>
                      <router-link to="/corporate-companies">Corporate Companies</router-link>
                    </li>
                    <li>
                      <router-link to="/getTouch"
                        >Get In Touch </router-link
                      >
                    </li>
                    <!-- <li><a href="#">Our Projects</a></li> -->
                    <!-- <li><a href="#">Our Partners</a></li> -->
                    <!-- <li><a href="#">FAQs</a></li> -->
                  </ul>

                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                <div class="links d-flex flex-column align-items-start">
                  <h4 class="mb-4">Get In Touch</h4>
                  <p>
                    We're here to answer questions, explore partnerships, and
                    support your success. Our team of experts is ready to help
                    you navigate global markets.
                  </p>
                  <router-link
                    to="/getTouch"
                    style="
                      background-color: #ddb657;
                      color: white;
                      padding: 18px 32px;
                      border-radius: 4px;
                      font-size: 18px;
                      font-weight: 700;
                    "
                  >
                    Get In Touch
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <mask
                          id="mask0_134_23007"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="22"
                          height="22"
                        >
                          <rect width="22" height="22" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_134_23007)">
                          <path
                            d="M12.1667 16L11 14.7917L13.9583 11.8333H3.83334V10.1667H13.9583L11 7.20833L12.1667 6L17.1667 11L12.1667 16Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="copyright d-flex justify-content-between">
            <div
              class="copy"
              style="display: flex; justify-content: center; width: 100%"
            >
              <p style="margin-bottom: 0px">
                © All rights reserved to ALJABIRI Holding Group Designed by
                <a
                  href="https://vdatait.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #ddb657; text-decoration: underline !important"
                >
                  Virtual Data IT
                </a>
              </p>
            </div>
            <!-- <div class="conditions d-flex">
              <span>Terms</span>
              <span>Privacy</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Autoplay, Keyboard } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
const modules = [Autoplay, Navigation];

const logos = [
  "/images/client-logo-1.png",
  "/images/client-logo-2.png",
  "/images/client-logo-8.png",
  "/images/client-logo-6.png",
  "/images/client-logo-9.png",
  "/images/client-logo-7.png",
  "/images/client-logo-3.png",
  "/images/client-logo-4.png",
  "/images/client-logo-10.png",
  "/images/client-logo-5.png",
  "/images/client-logo-11.png",
  "/images/client-logo-12.png",
  "/images/client-logo-13.png",
  "/images/client-logo-14.png",
  "/images/client-logo-15.png",
  "/images/client-logo-16.png",
  "/images/client-logo-17.png",
  "/images/client-logo-18.png",
  "/images/client-logo-19.png",
  "/images/client-logo-20.png",
  "/images/client-logo-21.png",
  "/images/client-logo-22.png",
  "/images/client-logo-23.png",
  "/images/client-logo-24.png",
  "/images/client-logo-25.png",
  "/images/client-logo-26.png",
  "/images/client-logo-27.png",
  "/images/client-logo-28.png",
  "/images/client-logo-29.png",


];
const swiperInstance = ref(null);
const onSwiper = (swiper) => {
  swiperInstance.value = swiper;
};
const goPrev = () => {
  if (swiperInstance.value) swiperInstance.value.slidePrev();
};

const goNext = () => {
  if (swiperInstance.value) swiperInstance.value.slideNext();
};

// Counter animation configuration
const counterTargets = [
  { value: 75, duration: 1100 },
  { value: 50, duration: 1200 },
  { value: 35, duration: 1400 },
  { value: 500, duration: 1500 }
];

const counters = ref(counterTargets.map(() => 0));
let hasAnimated = false;

const formatNumber = (num) => `${Math.floor(num)}+`;

const animateValue = (start, end, duration, index) => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (prefersReducedMotion) {
    counters.value[index] = end;
    return;
  }

  const startTimestamp = performance.now();
  const easeOutQuad = (t) => t * (2 - t); // Smooth ease-out function

  const updateCounter = (currentTimestamp) => {
    const elapsed = currentTimestamp - startTimestamp;
    const progress = Math.min(elapsed / duration, 1);
    
    counters.value[index] = Math.min(
      start + (end - start) * easeOutQuad(progress),
      end
    );

    if (progress < 1) {
      requestAnimationFrame(updateCounter);
    }
  };

  requestAnimationFrame(updateCounter);
};
import { onBeforeUnmount } from 'vue';

let io; // IntersectionObserver

onMounted(() => {
  // صفّر القيم عند الدخول للصفحة
  counters.value = counterTargets.map(() => 0);

  // راقب كل رقم على حدة
  const numEls = Array.from(
    document.querySelectorAll('.top-footer .statics .block .num')
  );
  if (!numEls.length) return;

  const started = new Set(); // لمنع التكرار

  io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const idx = numEls.indexOf(entry.target);
        if (idx === -1 || started.has(idx)) return;

        started.add(idx);
        const { value, duration } = counterTargets[idx];
        animateValue(0, value, duration, idx);

        io.unobserve(entry.target); // لا تراقب بعد البدء
      });
    },
    {
      root: null,
      threshold: 0.1,           // يبدأ عند ظهور 10% من الرقم
      rootMargin: '0px 0px -10% 0px', // يطلق قبل أن يملأ الشاشة بالكامل بقليل
    }
  );

  numEls.forEach((el) => io.observe(el));
});

onBeforeUnmount(() => {
  io?.disconnect?.();
});

</script>

<style scoped>
.client-logo {
  filter: grayscale(100%);
  transition: filter 0.3s ease-in-out;
}
.client-logo:hover {
  filter: grayscale(0%);
}
.carousel-width {
  width: 1100px;
}
@media (max-width: 1300px) {
  .carousel-width {
    width: 800px;
  }
}
@media (max-width: 1000px) {
  .carousel-width {
    width: 500px;
  }
}
@media (max-width: 650px) {
  .carousel-width {
    width: 300px;
  }
}
@media (max-width: 400px) {
  .carousel-width {
    width: 250px;
  }
}
.client-section {
  padding: 50px 0;
}

.client-logo-style-03 img {
  max-width: 140px;
  height: auto;
  margin: auto;
  transition: transform 0.3s;
}

.client-logo-style-03 img:hover {
  transform: scale(1.1);
}
.swiper-slide {
  height: 150px; /* or any fixed height you want */
  display: flex;
  align-items: center;
  justify-content: center;
}
.swiper-slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.num {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  min-width: 4ch;
  display: inline-block;
  font-weight: bold;
}

@media (prefers-reduced-motion: reduce) {
  .num {
    transition: none !important;
  }
}
</style>
